/**
 * Sonido de aviso dentro de la página. iPhone (Safari/Chrome) solo deja sonar audio después de
 * un toque del usuario: el contexto de audio se "desbloquea" con el primer toque y se reutiliza.
 */
let ctx: AudioContext | null = null;

function getCtx(): AudioContext | null {
  if (ctx) return ctx;
  const Ctx = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctx) return null;
  ctx = new Ctx();
  return ctx;
}

/** Llamar una vez al iniciar la app. */
export function unlockAudioOnFirstTouch() {
  const unlock = () => {
    const c = getCtx();
    if (c?.state === 'suspended') void c.resume();
    // Un sonido vacío termina de habilitar el audio en iOS.
    if (c) {
      const b = c.createBuffer(1, 1, 22050);
      const s = c.createBufferSource();
      s.buffer = b;
      s.connect(c.destination);
      s.start(0);
    }
    window.removeEventListener('pointerdown', unlock);
    window.removeEventListener('keydown', unlock);
  };
  window.addEventListener('pointerdown', unlock, { once: false });
  window.addEventListener('keydown', unlock, { once: false });
}

/** Tono de tres notas (aviso). */
export function playChime() {
  try {
    const c = getCtx();
    if (!c) return;
    if (c.state === 'suspended') void c.resume();
    [0, 0.35, 0.7].forEach((t, i) => {
      const o = c.createOscillator();
      const g = c.createGain();
      o.type = 'sine';
      o.frequency.value = i === 2 ? 1046 : 880;
      g.gain.setValueAtTime(0.0001, c.currentTime + t);
      g.gain.exponentialRampToValueAtTime(0.4, c.currentTime + t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + t + 0.3);
      o.connect(g).connect(c.destination);
      o.start(c.currentTime + t);
      o.stop(c.currentTime + t + 0.32);
    });
    navigator.vibrate?.([200, 100, 200]);
  } catch {
    /* sin audio */
  }
}
